<template>
  <sdz-modal
    ref="sdzModal"
    @close="close"
    :title="modalTitle"
    :disabled-confirm="isDisabled"
    @saveConfiguration="saveConfiguration"
    @cancelConfiguration="cancelConfiguration"
    confirm-button-label="Salvar"
    confirmation-event="saveConfiguration"
    cancel-event="cancelConfiguration"
    width="600"
    persistent
    custom-class="default-sheet-modal"
    buttons-position="right"
    close-icon
  >
    <template>
      <div
        class="content"
      >
        <AppLoadingIcon
          v-if="loading"
          class="loading"
          color="#BBB"
        />
        <template v-else>
          <div class="list-header">
            <span class="col-accelerator">
              <h3>Acelerador</h3>
            </span>
            <span class="col-items">
              <h3>Itens</h3>
            </span>
            <span class="col-sdz-prize">
              <h3>Prêmio</h3>
            </span>
          </div>
          <div class="item-list">
            <div
              v-for="(item, index) in accelerators"
              :key="index"
              class="list-item"
            >
              <div
                :class="{ 'text-disabled': isDisabled }"
                class="col-accelerator v-label theme--light"
              >
                <AppCheckBox
                  v-model="item.checked"
                  :disabled="isDisabled"
                  :options="[{ title: item.name, value: true}]"
                />
              </div>
              <div
                :class="{ 'text-disabled': isDisabled }"
                class="col-items v-label theme--light"
              >
                {{ getItens(item) }}
              </div>
              <div
                :class="{ 'text-disabled': isDisabled }"
                class="col-sdz-prize v-label theme--light"
              >
                {{ item.seedzPrize }}
              </div>
            </div>
          </div>
        </template>
      </div>
    </template>
  </sdz-modal>
</template>

<script>
  import AppCheckBox from '@/components/ui/inputs/AppCheckBox.vue'
  import AppLoadingIcon from '@/components/ui/AppLoadingIcon.vue'
import { excludeAcceleratorsPartner, getAllAccelerators } from '@/services/containers/partners/accelerator'

  export default {
    name: 'AcceleratorConfigModal',

    components: {
      AppCheckBox,
      AppLoadingIcon,
      SdzModal: () => import('@/components/sdz/SdzModal.vue')
    },

    props: {},

    data: () => ({
      loading: false,
      form: [],
      campaign: {},
      campaignCompany: {},
      accelerators: [{ _id: '1', name: 'Acelerador 1', seedzPrize: 100, items: [] }],
    }),

    computed: {
      modalTitle() {
        return `Configurar aceleradores - ${this.campaignCompany?.partner?.name}`
      },
      isDisabled() {
        const campaignPending = this.campaign.status === 'pending'
        const campaignCompanyWithoutApprovedLegal = !['approved', 'canceled'].includes(this.campaignCompany?.approvedLegal?.status)
        return !campaignPending || !campaignCompanyWithoutApprovedLegal
      }
    },

    methods: {
      getItens(item) {
        if (item.products?.length) {
          return item.products.map(item => item.product.name).join(' + ')
        }
        return item.brands?.map(item => item.brand.name).join(' + ')
      },
      async open({ campaign, campaignCompany }) {
        this.loading = true
        this.$refs.sdzModal.show = true
        this.campaign = campaign
        this.campaignCompany = campaignCompany
        const response = await getAllAccelerators(this.campaign._id)
        const excludeAcceleratorIds = this.campaignCompany?.accelerators?.excludeIds?.length
          ? this.campaignCompany?.accelerators.excludeIds
          : []
        this.accelerators = response.data.map((accelerator) => ({
          ...accelerator,
          checked: !excludeAcceleratorIds.includes(accelerator._id)
        }))
        this.loading = false
      },
      close() {
        this.$refs.sdzModal.show = false
      },
      cancelConfiguration() {
        this.close()
      },
      async saveConfiguration() {
        try {
          this.loading = true
          const excludeAcceleratorIds = this.accelerators
            .filter(accelerator => !accelerator.checked)
            .map(accelerator => accelerator._id)
          await excludeAcceleratorsPartner(this.campaign._id, this.campaignCompany.partner._id, excludeAcceleratorIds)
          this.close()
          this.$emit('update-dynamic-categories')
        } catch (error) {
          console.error('Error saving configuration:', error)
          this.$toast(error?.response?.data?.message || 'Erro ao salvar configuração', 'red')
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>

<style lang="stylus">
  .default-sheet-modal {
    .content {
      .text-disabled {
        color: rgba(0,0,0,.38);
      }

      .app-checkbox {
        .v-input__slot {
          margin: 0;
        }
        .v-messages {
          min-height: 0;
        }
      }

      padding: 20px 20px 20px 20px;

      .v-input--selection-controls {
        margin-top: 0;
        padding-top: 0;
      }
      
      .list-header {
        display: flex;
        padding: 0px 16px 12px 16px;
        font-weight: bold;
        color: #555;
      }

      .item-list {
        max-height: 350px;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: 8px;
      }

      .list-item {
        display: flex;
        align-items: center;
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        padding-bottom: 8px;
        padding-top: 8px;

        .col-accelerator {
          padding-left: 12px;
        }
      }

      .col-accelerator { flex: 2.5; }
      .col-items { flex: 4; }
      .col-sdz-prize { flex: 1; text-align: left; }

      .list-item div {
        display: flex;
        align-items: center;
      }

      .header-item-accelerator {
        flex: 2;
      }
      .header-item-items {
        flex: 3
      }
      .header-item-sdz-prize {
        flex: 1;
        text-align: left;
      }


      .cell-accelerator {
        flex: 2;
        display: flex;
        align-items: center;
      }
      .cell-items {
        flex: 3;
        color: #333;
      }
      .cell-sdz-prize {
        flex: 1;
        text-align: left;
        color: #333;
      }
    }
  }
</style>
